import { render } from "./BaseButton.vue?vue&type=template&id=76f371f9&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=76f371f9&scoped=true&lang=css"

import exportComponent from "D:\\Vue\\Course\\Section16\\main-prj-01-starting-setup\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f371f9"]])

export default __exports__